import { Box3, LineBasicMaterial, LineSegments, WireframeGeometry } from 'three';
import { SelectableObject3D } from './SelectableObject3D';
import { isMesh } from '../utils/typeUtils';
import { WIREFRAME_COLOR } from '../constants/constants';
export function isPart3D(object) {
    return object && object.isPart3D;
}
export var ObjectDisplayMode;
(function (ObjectDisplayMode) {
    ObjectDisplayMode[ObjectDisplayMode["Normal"] = 0] = "Normal";
    ObjectDisplayMode[ObjectDisplayMode["WireFrame"] = 1] = "WireFrame";
})(ObjectDisplayMode || (ObjectDisplayMode = {}));
export class Part3D extends SelectableObject3D {
    constructor(object) {
        super();
        this.wireFrames = [];
        this.meshes = [];
        this.mode = ObjectDisplayMode.Normal;
        this.isPart3D = true;
        this.object = object;
        this.add(object);
        this.populateWireframeData();
        this.setDisplayMode(ObjectDisplayMode.Normal);
        this.initBaseColors();
    }
    getObject() {
        return this.object;
    }
    getBoundingBox() {
        return new Box3().setFromObject(this.object);
    }
    static findPart3DAncestor(object) {
        if (object === null) {
            return null;
        }
        if (isPart3D(object)) {
            return object;
        }
        return Part3D.findPart3DAncestor(object.parent);
    }
    setDisplayMode(mode, modeCheck = false) {
        if (modeCheck && this.mode === mode) {
            return;
        }
        this.mode = mode;
        if (!this.visible) {
            return;
        }
        if (this.mode === ObjectDisplayMode.Normal) {
            this.meshes.forEach((mesh, idx) => {
                if (mesh.userData.mode === ObjectDisplayMode.Normal) {
                    return;
                }
                const wireFrame = this.wireFrames[idx];
                mesh.visible = wireFrame.visible;
                mesh.userData.mode = this.mode;
                wireFrame.visible = false;
            });
        }
        else if (this.mode === ObjectDisplayMode.WireFrame) {
            this.wireFrames.forEach((wireFrame, idx) => {
                const mesh = this.meshes[idx];
                if (mesh.userData.mode === ObjectDisplayMode.WireFrame) {
                    return;
                }
                wireFrame.visible = mesh.visible;
                mesh.visible = false;
                mesh.userData.mode = this.mode;
            });
        }
    }
    setChildDisplayMode(child, mode) {
        const userData = child.userData;
        const { wireframeUUID, meshId } = userData;
        if (userData.mode === mode) {
            mode = (mode === ObjectDisplayMode.Normal)
                ? ObjectDisplayMode.WireFrame
                : ObjectDisplayMode.Normal;
        }
        userData.mode = mode;
        if (mode === ObjectDisplayMode.Normal) {
            this.meshes.forEach((mesh, idx) => {
                if (mesh.uuid === meshId) {
                    const wireFrame = this.wireFrames[idx];
                    mesh.visible = wireFrame.visible;
                    wireFrame.visible = false;
                }
            });
        }
        else if (mode === ObjectDisplayMode.WireFrame) {
            this.wireFrames.forEach((wireFrame, idx) => {
                if (wireFrame.uuid === wireframeUUID) {
                    const mesh = this.meshes[idx];
                    wireFrame.visible = mesh.visible;
                    mesh.visible = false;
                }
            });
        }
    }
    getChildDisplayMode(child) {
        const { mode } = child.userData;
        return mode;
    }
    getDisplayMode() {
        return this.mode;
    }
    populateWireframeData() {
        this.meshes = [];
        this.wireFrames = [];
        this.object.traverse((child) => {
            var _a;
            if (isMesh(child)) {
                this.meshes.push(child);
                const wireframe = new LineSegments(new WireframeGeometry(child.geometry), new LineBasicMaterial({ color: WIREFRAME_COLOR }));
                wireframe.userData.isWireframe = true;
                child.userData.isVisible = true;
                child.userData.meshId = child.uuid;
                child.userData.wireframeUUID = wireframe.uuid;
                child.userData.wireframe = wireframe;
                this.wireFrames.push(wireframe);
                (_a = child.parent) === null || _a === void 0 ? void 0 : _a.add(wireframe);
            }
        });
    }
}
